<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="931"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.PleaseEnterTheWarehouseNumber')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--查看-->
          <el-button no="look" :disabled="!selectedData" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <!--入库-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_warehousing'])" no="warehouseIn" type="primary" @click="onWarehouseIn()">{{ $t('Warehouse.WarehouseIn') }}</el-button>
          <!--称重-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_weighingMeasuring'])" no="weigh" :disabled="!selectedData" type="primary" @click="onWeigh()">{{ $t('Warehouse.Weigh') }}</el-button>
          <!--核单-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_verifyWarehouse'])" no="checklist" :disabled="!selectedData" type="primary" @click="onCheckList()">{{ $t('Warehouse.Checklist') }}</el-button>
          <!--撤销核单-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_cancelWarehouseResult'])" no="rollbackChecklist" :disabled="!selectedData" type="warning" @click="rollbackChecklist()">{{ $t('FbaChannel.revokeTheApprovalForm') }}</el-button>
          <!--登记面单-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_registerExpressInvoice'])" no="onRegistrationSlip" :disabled="!selectedData" type="primary" @click="onRegistrationSlip()">{{ $t('Warehouse.RegistrationSlip') }}</el-button>
          <!--装箱-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_packing'])" no="onPacking" :disabled="!selectedData" type="primary" @click="onPacking()">{{ $t('Warehouse.Packing') }}</el-button>
          <!--出库-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_outBound'])" no="onExWarehouse" :disabled="!selectedData" type="primary" @click="onExWarehouse()">{{ $t('Warehouse.ExWarehouse') }}</el-button>
          <!--撤销出库-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_cancelOutbound'])" no="rollbackExWarehouse" :disabled="!selectedData" type="warning" @click="rollbackExWarehouse()">{{ $t('FbaChannel.revokeOutboundShipment') }}</el-button>
          <!--退件-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_cancelOrder'])" no="onReturnGoods" :disabled="!selectedData" type="primary" @click="onReturnGoods()">{{ $t('Warehouse.ReturnGoods') }}</el-button>
          <!--编辑-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_editWarehouse'])" no="edit" :disabled="!selectedData" type="success" @click="editHandler()">{{ $t('SeaExport.Edit') }}</el-button>
          <!--删除-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_deleteWarehouse'])" no="delete" :disabled="!selectedData" type="danger" @click="batchDelete()">{{ $t('SeaExport.Delete') }}</el-button>
          <!--打印-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_printWarehouse'])" no="print" :disabled="!selectedData" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
          <!--统计-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_statistical'])" no="statistics" type="primary" @click="statisticsPage()">{{ $t('SeaExport.Statistics') }}</el-button>
          <!--全部导出Excel-->
          <el-button v-if="$checkPermission(['button_FBAWarehousing_allExport'])" no="exportAllToExcel" type="primary" @click="exportAllToExcel()">{{ $t('SeaExport.ExportAllToExcel') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="9300006"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="9300006"
          :total="total"
          :page.sync="filterJson.pageNum"
          :limit.sync="filterJson.pageSize"
          @pagination="toQueryByPage"
        />
      </div>
      <!-- 退件 -->
      <el-dialog
        v-if="returnGoods.visible"
        v-el-drag-dialog
        :visible.sync="returnGoods.visible"
        :title="$t('Warehouse.ReturnGoods')"
        width="340px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item :label="$t('Warehouse.ReturnGoodsTime')">
            <el-date-picker v-model="returnGoods.returnGoodsTime" no="returnGoodsTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:100%" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.ReturnReason')">
            <el-input v-model="returnGoods.returnReason" no="returnReason" style="width:100%" type="textarea" :rows="5" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toReturnGoods">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="returnGoods.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 核单 -->
      <el-dialog
        v-if="checklist.visible"
        v-el-drag-dialog
        :visible.sync="checklist.visible"
        :title="$t('Warehouse.Checklist')"
        width="340px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item :label="$t('Warehouse.ChecklistTime')">
            <el-date-picker v-model="checklist.checklistTime" no="checklistTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:195px" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.ChecklistResult')">
            <el-select v-model="checklist.checklistStatus" no="checklistStatus" style="width:195px;" placeholder="">
              <el-option
                v-for="item in SystemConstants.CHECKLIST_STATUS"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Warehouse.HandlingOpinions')">
            <el-input v-model="checklist.comments" type="textarea" :row="5" style="width:195px;" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toChecklist">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="checklist.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 登记面单 -->
      <el-dialog
        v-if="registrationSlip.visible"
        v-el-drag-dialog
        :visible.sync="registrationSlip.visible"
        :title="$t('Warehouse.RegistrationSlip')"
        width="540px"
        :close-on-click-modal="false"
      >
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Warehouse.WarehouseNo')">
            <el-input v-model="registrationSlip.warehouseNo" no="warehouseNo" :disabled="true" style="width:100%" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.mailingAddress.fbaWarehouseCode')">
            <cargo-advance-select
              :disabled="true"
              no="fbaWarehouseCode"
              :select-type="selectTypeNames.basic_data_OverseaWarehouse"
              filterable
              :fields="['warehouseCode']"
              :callback-params="{key:'warehouseCode'}"
              callback-method-type="value"
              tag-value="warehouseCode"
              tag-name="warehouseCode"
              :default-value="registrationSlip.warehouseCode"
              style="width:100%"
              @parentCallBack="item=>registrationSlip.warehouseCode=item.value"
            />
          </el-form-item>
          <!-- 实际件毛体-->
          <el-form-item label-width="0">
            <cargo-ag-grid
              :show-side-bar="false"
              :grid-options="registrationSlip.gridOptions"
              :column-defs="registrationSlip.columnDefs"
              :row-data="registrationSlip.rowData"
              :grid-params.sync="registrationSlip.gridParams"
              style="width: 100%;"
              @gridReady="params=>registrationSlip.gridApi=params.api"
            />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.CourierServicesCompany')">
            <el-input v-model="registrationSlip.expressCompany" no="expressCompany" style="width:100%" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.CourierNumber')">
            <el-input v-model="registrationSlip.courierNumber" no="courierNumber" style="width:100%" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PrintTime')">
            <el-date-picker v-model="registrationSlip.faceOrderPrintTime" no="faceOrderPrintTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width:100%" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toRegistrationSlip">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="registrationSlip.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 装箱 -->
      <el-dialog
        v-if="packing.visible"
        v-el-drag-dialog
        :visible.sync="packing.visible"
        :title="$t('Warehouse.Packing')"
        width="340px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item :label="$t('SpecialGoods.StuffingTime')">
            <el-date-picker v-model="packing.packingTime" no="packingTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:100%" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.RefContainerNo')">
            <el-input v-model="packing.refContainerNo" no="refContainerNo" style="width:100%" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toPacking">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="packing.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 出库 -->
      <el-dialog
        v-if="exWarehouse.visible"
        v-el-drag-dialog
        :visible.sync="exWarehouse.visible"
        :title="$t('Warehouse.ExWarehouse')"
        width="340px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item :label="$t('Warehouse.DeliveryDate')">
            <el-date-picker v-model="exWarehouse.warehouseOutDate" no="warehouseOutDate" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:100%" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
          <el-form-item
            :label="$t('Warehouse.DeliveryMode')"
            prop="outType"
            class="auto-width"
          >
            <el-select
              v-model="exWarehouse.outType"
              clearable
              style="width: 95%;"
              :placeholder="$t('Message.PleaseSelect')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in WarehouseInState.WAREHOUSE_IN_OUT_TYPE"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toExWarehouse">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="exWarehouse.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 统计    -->
      <warehouse-statistics-window
        v-if="statistics.show"
        :visible.sync="statistics.show"
        :warehouses-list="statistics.warehousesList"
      />
      <!-- 查询进仓照片 -->
      <picture-view-window :visible.sync="pictureView.visible" :job="pictureView.j" :model="pictureView.model" :title="pictureView.title" :file-name="pictureView.fileName" :type="pictureView.type" />
    </div>
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import {
  removeFunc,
  fbaQuery,
  updateFields,
  batchRemoveFunc
} from '@/api/warehouseIn/warehouseIn'
import warehouseStatisticsWindow from '@/components/Cargo/Warehouse/components/warehousing/warehouseStatisticsWindow'
import pictureViewWindow from '@/components/Cargo/Job/pictureViewWindow'
import { getJobByUuid } from '@/api/booking/job'
import StrUtils from '@/utils/StrUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import moment from 'moment'
import { getFbaWarehouseInDetail } from '@/api/booking/warehouseInDetail'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { TabError } from '@/utils/class/TabError'
import CustomLableUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'FbaWarehousingTreeGrid',
  components: {
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    warehouseStatisticsWindow,
    pictureViewWindow
  },
  props: {
    context: { type: Object, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      SystemConstants,
      WarehouseInState,
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      isEditing: false,
      filterJson: {
        pageNum: 1,
        pageSize: 10
      },
      filter: {
        pageNum: 1,
        pageSize: 10,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      // 退件
      returnGoods: {
        visible: false,
        returnGoodsTime: '',
        returnReason: ''
      },
      // 核单
      checklist: {
        visible: false,
        checklistTime: '',
        comments: '',
        checklistStatus: 1
      },
      // 登记打印面单
      registrationSlip: {
        visible: false,
        faceOrderPrintTime: '', // 打印时间
        courierNumber: '', // 快递单号
        expressCompany: '', // 快递公司
        warehouseCode: '', // 仓库代码
        warehouseNo: '', // 进仓编号
        rowData: [],
        gridParams: {},
        columnDefs: [
          { headerName: '件', field: 'boxesNumber', width: 50, colId: 'boxesNumber' },
          { headerName: 'KG', field: 'weight', width: 50, colId: 'weight' },
          { headerName: '长', field: 'boxLength', width: 50, colId: 'boxLength' },
          { headerName: '宽', field: 'boxWidth', width: 50, colId: 'boxWidth' },
          { headerName: '高', field: 'boxHeight', width: 50, colId: 'boxHeight' }
        ],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        },
        gridApi: null
      },
      // 装箱
      packing: {
        visible: false,
        packingTime: '',
        refContainerNo: ''
      },
      // 出库
      exWarehouse: {
        visible: false,
        warehouseOutDate: '',
        outType: ''
      },
      // 图片展示
      pictureView: {
        visible: false,
        title: '',
        model: {},
        fileName: '',
        j: {},
        type: 'WarehouseIn'
      },
      // 统计
      statistics: {
        show: false,
        warehousesList: []
      },
      total: 0,
      selectedData: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        onCellDoubleClicked: event => {
          this.toLook(event.data)
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
          if (event && event.api && event.api) {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },
        context: {
          componentParent: this
        }
      },
      export: {},
      rowData: [],
      gridApi: null,
      documentManage: new DocumentManage(),
      templateSelectorDialog: { // 打印弹窗
        visible: false,
        ctx: new WarehouseIn(),
        category: '',
        data: {}
      },
      cbAutoRefresh: true
    }
  },
  computed: {
    isFba() { // 是否fba
      return this.lob === 'FBA'
    },
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 240, colId: 'jobNo', lockVisible: true },
        { headerName: this.$t('SeaExport.WarehouseNo'), field: 'warehouseNo', width: 180, colId: 'warehouseNo', lockVisible: true },
        { headerName: 'Shipment ID', field: 'shipmentId', width: 180, colId: 'shipmentId' },
        { headerName: this.$t('Warehouse.CommissionNo'), field: 'commissionNo', width: 180, colId: 'commissionNo' },
        { headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'), field: 'customerId', width: 180, colId: 'customerId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Warehouse.ReceivingWarehouse'), field: 'receivingWarehouse', width: 180, colId: 'receivingWarehouse',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_10') : ''
          } },
        { headerName: this.$t('FbaJob.AmazonWarehouseCode'), field: 'warehouseCode', width: 180, colId: 'warehouseCode' },
        { headerName: this.$t('Warehouse.ServiceChannel'), field: 'serviceChannel', width: 180, colId: 'serviceChannel' },
        { headerName: 'Reference Id', field: 'referenceId', width: 180, colId: 'referenceId' },
        { headerName: this.$t('Pricing.TransportMode'), field: 'shippingType', width: 180, colId: 'shippingType',
          valueFormatter: (params) => {
            return ColumnUtils.shippingTypeLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_PortOfLoading'), field: 'loadingPortCode', width: 180, colId: 'loadingPortCode',
          valueFormatter: (params) => {
            let portName = ''
            if (params.data.lob === 'SE' || params.data.lob === 'SI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.lob === 'AE' || params.data.lob === 'AI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else if (params.data.lob === 'RE') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
            }
            return (!StrUtils.isEmpty(portName)) ? portName : params.value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_IncoTerm'), field: 'incoTerm', width: 180, colId: 'incoTerm' },
        { headerName: this.$t('Warehouse.PoOriginalOrderNo'), field: 'poNumber', width: 180, colId: 'poNumber', hide: true },
        { headerName: this.$t('CargoMsg.Cargo_FLCLType'), field: 'containerLoadType', width: 180, colId: 'containerLoadType',
          valueFormatter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          } },
        { headerName: this.$t('SeaExport.PackageType'), field: 'packing', width: 180, colId: 'packing', hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', params.value, 'name') || params.value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ValueAddedServices'), field: 'valueAddedServices', width: 180, colId: 'valueAddedServices' },
        { headerName: this.$t('Warehouse.RemoteWarehouse'), field: 'remoteWarehouse', width: 180, colId: 'remoteWarehouse',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Warehouse.EstEnteringAmazonWarehouse'), field: 'preAmazonWhTime', width: 180, colId: 'preAmazonWhTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_EstTimeOfWarehouseIn'), field: 'estimatedDateOfWarehousinge', width: 180, colId: 'estimatedDateOfWarehousinge',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Warehouse.ChargingMethod'), field: 'chargingMethod', width: 180, colId: 'chargingMethod',
          valueFormatter: (params) => {
            return params === '0' ? 'KG' : 'CBM'
          }
        },
        { headerName: this.$t('Warehouse.Total') + this.$t('Warehouse.NumberOfCases') + '(' + this.$t('CargoMsg.Cargo_Consignation') + ')', field: 'quantityContract', width: 180, colId: 'quantityContract',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          }
        },
        { headerName: this.$t('Warehouse.Total') + this.$t('Warehouse.Weight') + '(' + this.$t('CargoMsg.Cargo_Consignation') + ')', field: 'weightContract', width: 180, colId: 'weightContract',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('Warehouse.Total') + this.$t('Warehouse.Volume') + '(' + this.$t('CargoMsg.Cargo_Consignation') + ')', field: 'cubageContract', width: 180, colId: 'cubageContract',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 3, true)
          }
        },
        { headerName: this.$t('Warehouse.Total') + this.$t('Warehouse.NumberOfCases') + '(' + this.$t('SeaExport.Actual') + ')', field: 'quantitySum', width: 180, colId: 'quantitySum',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          }
        },
        { headerName: this.$t('Warehouse.Total') + this.$t('Warehouse.Weight') + '(' + this.$t('SeaExport.Actual') + ')', field: 'weightSum', width: 180, colId: 'weightSum',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('Warehouse.Total') + this.$t('Warehouse.Volume') + '(' + this.$t('SeaExport.Actual') + ')', field: 'cubageSum', width: 180, colId: 'cubageSum',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 3, true)
          }
        },
        { headerName: this.$t('Warehouse.WeighTime'), field: 'weighTime', width: 180, colId: 'weighTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('FbaJob.Op'), field: 'op', width: 120,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          } },
        { headerName: this.$t('FbaJob.Sales'), field: 'sales', width: 120,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          } },
        { headerName: this.$t('FbaJob.Csr'), field: 'csr', width: 120,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_csr')
          } },
        { headerName: this.$t('FbaJob.Dc'), field: 'dc', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('Warehouse.ReturnReason'), field: 'returnReason', width: 180, colId: 'returnReason' },
        { headerName: this.$t('Warehouse.ChecklistTime'), field: 'checklistTime', width: 180, colId: 'checklistTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Warehouse.ReturnGoodsTime'), field: 'returnGoodsTime', width: 180, colId: 'returnGoodsTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }
      ]
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.loading = getLoading()
    this.fbaQueryFunc(true)
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
    this.documentManage.set('showAttachHandler', function() {
      context.showAttachHandler()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedData = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeWarehouse = node.data
            if (nodeWarehouse.uuid) this.selectedData = nodeWarehouse
          }
        })
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    getMAWBLabel() {
      let label = ''
      switch (this.lob) {
        case 'RE':
          label = this.$t('Billing.WayBillNumber')
          break
        case 'AE':
        case 'AI':
          label = 'MAWB'
          break
        case 'SE':
        case 'SI':
          label = 'MB/L'
          break
        case 'FBA':
          label = this.$t('SeaExport.MasterBillNo')
          break
      }
      return label
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      this.selectedData = null
      if (event.node.isSelected()) {
        this.onRowClicked(event)
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) this.selectedData = node
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.init()
    },
    init() {},
    // 查询[简单查询/高级查询]
    toQuery() {
      this.filter.pageNum = 1
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.filter.warehouseNo = ''
      this.filter.conditions = []
      this.filter.lob = this.lob
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
        this.filter.conditions = [... data]
        this.filter.pageNum = 1
      }
      this.filter.pageNum = this.filterJson.pageNum
      this.filter.pageSize = this.filterJson.pageSize
      this.loading = getLoading()
      this.fbaQueryFunc()
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.warehouseNo = keyword.trim()
        this.filter.pageNum = 1
        this.filter.lob = this.lob
      }
      const conditions = []
      this.filter.conditions = conditions
      this.fbaQueryFunc()
    },
    // fba查询
    fbaQueryFunc(defaultSearch = false) {
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.defaultSearch = defaultSearch
      fbaQuery(this.filter).then(res =>
        this.handleQueryData(res)
      ).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filterJson.pageNum = res.data.pageNum
      this.filterJson.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.selectedData = null
      if (this.gridApi) this.gridApi.clearFocusedCell()
      if (this.loading) this.loading.close()
    },
    updateListData(res) {
      this.rowData = res
    },
    // 显示进仓图片
    showAttachHandler(e) {
      if (!this.selectedData) {
        this.$message.warning('请选择一条数据！')
        return
      }
      this.pictureView.title = this.$t('Message.ViewWarehouseEntryPhotos')
      this.pictureView.model = this.selectedData
      this.pictureView.fileName = this.selectedData.warehouseNo + '.zip'
      this.pictureView.type = 'WarehouseIn'
      if (this.selectedData.jobUuid) {
        getJobByUuid(this.selectedData.jobUuid).then(res => {
          this.pictureView.j = res.data
          this.pictureView.visible = true
        })
      } else {
        this.pictureView.j = {}
        this.pictureView.visible = true
      }
    },
    // 查看
    toLook(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.$emit('look', row)
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    getRowData(row) {
      if (!row) {
        row = this.selectedData
      }
      if (!row) {
        const rows = this.readSelectedRows()
        if (rows && rows.length > 0) {
          row = rows[0]
        }
      }
      return row
    },
    // 编辑
    editHandler(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (row.instoreFrom) {
        this.$message.info(this.$t('Warehouse.ExternallyImportedDataCannotEdit'))
        return
      }
      if (row.warehouseOutDate) {
        this.$message.warning(this.$t('Warehouse.cannotEditOutData'))
        return
      }
      this.$emit('edit', row)
    },
    // 删除
    deleteHandler(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (row.instoreFrom) {
        this.$message.info(this.$t('Message.ExternalDataCannotBeDeleted'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDeleteWarehouse'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        removeFunc({ warehouseInUuid: row.uuid }).then(resp => {
          this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
          this.toQueryByPage()
        }).catch(() => {
          this.loading.close()
        }).finally(() => this.loading.close())
      })
    },
    // 批量删除
    batchDelete() {
      const rows = this.readSelectedRows()
      if (!rows || (rows && rows.length < 1)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const deleteUuidList = []
      for (const row of rows) {
        if (row.instoreFrom) {
          this.$message.info(this.$t('Message.ExternalDataCannotBeDeleted'))
          return
        }
        if (row.checklistStatus) {
          this.$message.warning(this.$t('Warehouse.delChecklistData'))
          return
        }
        deleteUuidList.push(row.uuid)
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDeleteWarehouse'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        batchRemoveFunc({ deleteUuidList: deleteUuidList }).then(resp => {
          this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
          this.toQueryByPage()
        }).catch(() => {
          this.loading.close()
        }).finally(() => this.loading.close())
      })
    },
    // 打印
    onPrintHandler() {
      let rows = []
      const selectedRows = this.readSelectedRows()
      if (!this.selectedData && selectedRows.length === 1) {
        rows = this.selectedData
      } else {
        rows = selectedRows
      }
      this.$emit('print', rows)
    },
    // 获取勾选行
    readSelectedRows() {
      return this.gridApi.getSelectedRows()
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      if (!this.selectedData) return
      this.templateSelectorDialog.ctx = new WarehouseIn(this.selectedData)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedData.uuid }
      this.templateSelectorDialog.visible = true
    },
    statisticsPage(e) {
      const selectedList = this.readSelectedRows()
      if (!selectedList || selectedList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.statistics.show = true
      this.statistics.warehousesList = selectedList
    },
    // 全部导出
    exportAllToExcel() {
      this.export = {}
      const data = this.filter.snapshotConditions
      this.export.pageNum = 1
      this.export.pageSize = 10000
      this.export.lob = this.lob
      this.export.conditions = []
      this.export.branchId = this.$store.getters.currentOfficeId
      if (this.isAdvancedQuery) {
        if (typeof data !== 'undefined') {
          this.export.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
          this.export.conditions = [... data]
        }
      } else {
        this.export.warehouseNo = ''
      }
      this.loading = getLoading(null, { fullscreen: false })
      // 导出全部，需要 实时获取 用户的 搜索条件
      fbaQuery(this.export).then(res => {
        const { columnApi } = this.gridOptions
        // 获取显示列
        const allDisplayedColumns = columnApi.getAllDisplayedColumns()
        const fileName = '国内仓' + '_' + moment().format('YYYYMMDDHHmmss')
        exportExcel(fileName, res.data.list, allDisplayedColumns)
      }).finally(() => {
        this.loading.close()
      })

      // fbaGnExportAllToExcelFunc(this.export).then(res => {
      //   convertResToBlob(res)
      //   this.$message.success(this.$t('Message.RequestSucceededExporting'))
      //   this.loading.close()
      // }).catch((err) => {
      //   this.$message.error(err)
      //   this.loading.close()
      // })
    },
    // 入库
    onWarehouseIn() {
      this.$emit('add')
    },
    // 称重
    async onWeigh(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (row.checklistTime) {
        this.$message.warning(this.$t('Warehouse.weighCheckMsg', [this.$t('Warehouse.Checklist')]))
        return
      }
      if (row.packingTime) {
        this.$message.warning(this.$t('Warehouse.weighCheckMsg', [this.$t('Warehouse.Packing')]))
        return
      }
      if (row.warehouseOutDate) {
        this.$message.warning(this.$t('Warehouse.weighCheckMsg', [this.$t('Warehouse.ExWarehouse')]))
        return
      }
      let isContinue = true
      if (row.weighTime) {
        await this.$confirm(this.$t('Warehouse.CheckWeighTime'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          isContinue = false
        })
      }
      if (isContinue) {
        row.opType = 'weigh'
        this.$emit('edit', row)
      }
    },
    // 核单-单票/多票【单票进详情、多票走弹框】
    onCheckList(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (selects.length > 1) {
        // 多票走这里
        for (const cur of selects) {
          if (cur.checklistStatus) {
            this.$message.warning(this.$t('Warehouse.alreadyChecklist'))
            return
          }
          const isWeigh = this.checkActGoodsDetail(cur)
          if (!isWeigh) {
            // 选择的数据中包含未称重数据，请检查。
            this.$message.warning(this.$t('Warehouse.ChecklistTip'))
            return
          }
        }
        this.checklist.checklistTime = ''
        this.checklist.comments = ''
        this.checklist.checklistStatus = 1
        this.checklist.visible = true
      } else {
        if (row.checklistStatus) {
          this.$message.warning(this.$t('Warehouse.alreadyChecklist'))
          return
        }
        const isWeigh = this.checkActGoodsDetail(row)
        if (!isWeigh) {
          // 选择的数据中包含未称重数据，请检查。
          this.$message.warning(this.$t('Warehouse.ChecklistTip'))
          return
        }
        // 单票走这里
        row.opType = 'checklist'
        this.$emit('edit', row)
      }
    },
    // 验证实际货物明细和实际件毛体
    checkActGoodsDetail(cur) {
      let isWeigh = true
      // 实际货物明细条数
      if (!cur.warehouseInDetailCount || cur.warehouseInDetailCount <= 0) {
        isWeigh = false
      }
      // 实际件数
      if (isWeigh && !cur.quantitySum || cur.quantitySum <= 0) {
        isWeigh = false
      }
      // 实际重量
      if (isWeigh && !cur.weightSum || cur.weightSum <= 0) {
        isWeigh = false
      }
      // 实际体积
      if (isWeigh && !cur.cubageSum || cur.cubageSum <= 0) {
        isWeigh = false
      }
      return isWeigh
    },
    // 确定核单
    async toChecklist() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (!this.checklist.checklistTime) {
        this.$message.warning(this.$t('Warehouse.ChecklistTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.checklist.checklistStatus && Number(this.checklist.checklistStatus) !== 0) {
        this.$message.warning(this.$t('Warehouse.ChecklistResult') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (this.checklist.checklistStatus != null && !this.checklist.checklistStatus) {
        if (!this.checklist.comments) {
          this.$message.warning(this.$t('Message.PleaseEnterComments'))
          return
        }
      }
      const checklistTime = moment(this.checklist.checklistTime).format('YYYY-MM-DD HH:mm')
      // let warehouseNo = ''
      let isWeigh = true
      for (const select of selects) {
        if (select.weighTime) {
          const weighTime = moment(select.weighTime).format('YYYY-MM-DD HH:mm')
          if (weighTime > checklistTime) {
            this.$message.warning(this.$t('Warehouse.ChecklistTimeTip', [checklistTime, weighTime]))
            return
          }
        }
        // // 判断是否有称重时间
        // if (!select.weighTime && !warehouseNo) {
        //   warehouseNo = select.warehouseNo
        // }
        isWeigh = this.checkActGoodsDetail(select)
      }
      let isContinue = true
      if (!isWeigh) {
        await this.$confirm(this.$t('Warehouse.ChecklistTipOne'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          isContinue = false
        })
      }
      if (!isContinue) return
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_CHECKLIST
      obj.anyDate = this.checklist.checklistTime
      obj.anyInteger = this.checklist.checklistStatus
      obj.anyStr1 = this.checklist.comments // 处理意见
      this.loading = getLoading()
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.Checklist') + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.checklistTime = this.checklist.checklistTime
            cur.checklistStatus = this.checklist.checklistStatus
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.checklist.visible = false
        this.loading.close()
      })
    },
    // 撤销核单
    async rollbackChecklist() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      for (const select of selects) {
        if (!select.checklistTime) {
          this.$message.warning('选择的数据中包含未核单数据，请检查。')
          return
        }
        if (select.packingTime) {
          this.$message.warning('选择的数据中包含已装箱数据，请检查。')
          return
        }
        if (select.warehouseOutDate) {
          this.$message.warning('选择的数据中包含已出库数据，请检查。')
          return
        }
        if (select.faceOrderPrintTime) {
          this.$message.warning('选择的数据中包含已打印快递面单数据，请检查。')
          return
        }
      }
      let isContinue = true
      await this.$confirm('撤销核单后将清空核单时间和国外仓待入库记录，是否继续？', this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
      }).catch(() => {
        isContinue = false
      })
      if (!isContinue) return
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_ROLLBACK_CHECKLIST
      this.loading = getLoading()
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success('撤销核单' + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.checklistTime = null
            cur.checklistStatus = 0
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 退件
    async onReturnGoods() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      let isContinue = true
      for (const select of selects) {
        let msg = ''
        if (select.checklistTime) {
          msg = '已核单'
        } else if (select.packingTime) {
          msg = '装箱'
        } else if (select.warehouseOutDate) {
          msg = '出库'
        }
        if (msg) {
          await this.$confirm(this.$t('Warehouse.ReturnGoodsTips', [msg]), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
            isContinue = false
          })
          break
        }
      }
      if (isContinue) {
        this.returnGoods.returnGoodsTime = ''
        this.returnGoods.returnReason = ''
        this.returnGoods.visible = true
      }
    },
    // 确定退件
    toReturnGoods() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (!this.returnGoods.returnGoodsTime) {
        this.$message.warning(this.$t('Warehouse.ReturnGoodsTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.returnGoods.returnReason) {
        this.$message.warning(this.$t('Warehouse.ReturnReason') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.loading = getLoading()
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_RETURNGOODS
      obj.anyDate = this.returnGoods.returnGoodsTime
      obj.anyStr1 = this.returnGoods.returnReason
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.ReturnGoods') + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.returnGoodsTime = this.returnGoods.returnGoodsTime
            cur.returnReason = this.returnGoods.returnReason
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.returnGoods.visible = false
        this.loading.close()
      })
    },
    // 登记面单
    async onRegistrationSlip(row) {
      const cur = this.getRowData(row)
      if (!cur) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (!cur.destinationDistribution || Number(cur.destinationDistribution) !== 1) {
        this.$message.warning('目的地配送方式不是快递，不需要登记面单。')
        return
      }
      // if (cur.destinationDistribution !== '快递') {
      //   this.$message.warning(this.$t('Warehouse.FaceListCheckExpressDelivery'))
      //   return
      // }
      const isWeigh = this.checkActGoodsDetail(cur)
      let isContinue = true
      if (!isWeigh) {
        await this.$confirm(this.$t('Warehouse.FaceListCheckTip'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          isContinue = false
        })
      }
      if (!isContinue) return
      // 实际货物明细
      this.$nextTick(async() => {
        const warehouseInDetail = await getFbaWarehouseInDetail({ warehouseInUuid: cur.uuid }).then(res => res.data)
        this.registrationSlip.rowData = warehouseInDetail || []
      })
      this.registrationSlip.expressCompany = cur.expressCompany
      this.registrationSlip.warehouseCode = cur.warehouseCode
      this.registrationSlip.warehouseNo = cur.warehouseNo
      this.registrationSlip.faceOrderPrintTime = new Date()
      this.registrationSlip.courierNumber = ''
      this.registrationSlip.visible = true
    },
    // 确定登记面单
    toRegistrationSlip() {
      const row = this.getRowData()
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (!this.registrationSlip.faceOrderPrintTime) {
        this.$message.warning(this.$t('SeaExport.PrintTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.registrationSlip.courierNumber) {
        this.$message.warning(this.$t('Warehouse.CourierNumber') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const obj = {}
      obj.keys = [row.uuid]
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_REGISTRATIONSLIP
      obj.anyDate = this.registrationSlip.faceOrderPrintTime
      obj.anyStr1 = this.registrationSlip.courierNumber
      this.loading = getLoading()
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.RegistrationSlip') + this.$t('Message.Success'))
          row.faceOrderPrintTime = this.registrationSlip.faceOrderPrintTime
          row.courierNumber = this.registrationSlip.courierNumber
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.registrationSlip.visible = false
        this.loading.close()
      })
    },
    // 装箱
    async onPacking() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      let isContinue = true
      for (const select of selects) {
        if (select.packingTime) {
          this.$message.warning(this.$t('Warehouse.repeatPackingData'))
          return
        }
        if (select.returnGoodsTime) { // 包含已退件数据，不能装箱，请核查。
          this.$message.warning(this.$t('Warehouse.PackingTipOne'))
          return
        }
        if ((!select.checklistTime || !select.checklistStatus) && isContinue) { // 这个只要进一次即可
          await this.$confirm(this.$t('Warehouse.PackingTipTwo'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
            isContinue = false
          })
        }
      }
      if (isContinue) {
        this.packing.packingTime = ''
        this.packing.refContainerNo = ''
        this.packing.visible = true
      }
    },
    // 确定装箱
    toPacking() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (!this.packing.packingTime) {
        this.$message.warning(this.$t('SpecialGoods.StuffingTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.packing.refContainerNo) {
        this.$message.warning(this.$t('Warehouse.RefContainerNo') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.loading = getLoading()
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_PACKING
      obj.anyDate = this.packing.packingTime
      obj.anyStr1 = this.packing.refContainerNo
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.Packing') + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.packingTime = this.packing.packingTime
            cur.refContainerNo = this.packing.refContainerNo
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.packing.visible = false
        this.loading.close()
      })
    },
    // 出库
    onExWarehouse() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      for (const select of selects) {
        if (select.warehouseOutDate) { // 选择的数据中包含已出库数据，请核查
          this.$message.warning(this.$t('Warehouse.ExWarehouseTip'))
          return
        }
      }
      this.exWarehouse.warehouseOutDate = ''
      this.exWarehouse.visible = true
    },
    // 确定出库
    toExWarehouse() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (!this.exWarehouse.warehouseOutDate) {
        this.$message.warning(this.$t('Warehouse.DeliveryDate') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.loading = getLoading()
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_EXWAREHOUSE
      obj.anyDate = this.exWarehouse.warehouseOutDate
      obj.anyStr1 = this.exWarehouse.outType
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.ExWarehouse') + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.warehouseOutDate = this.exWarehouse.warehouseOutDate
            cur.outType = this.outType
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.exWarehouse.visible = false
        this.loading.close()
      })
    },
    // 撤销出库
    async rollbackExWarehouse() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      for (const select of selects) {
        if (!select.warehouseOutDate) {
          this.$message.warning('选择的数据中包含未出库数据，请检查.')
          return
        }
      }
      let isContinue = true
      await this.$confirm('撤销出库后将清空出库时间，是否继续？', this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
      }).catch(() => {
        isContinue = false
      })
      if (!isContinue) return
      this.loading = getLoading()
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_ROLLBACK_EXWAREHOUSE
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success('撤销出库' + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.warehouseOutDate = null
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
  #app #verify-tree-grid {
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #acbcca;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }

  }
</style>
